import React from 'react';
import { Link, RouteContext } from '../router.jsx';
import Icon from './Icon.jsx';

const studentLinks = [
  { to: '/student', label: 'Dashboard', icon: 'home' },
  { to: '/student/study-plan', label: 'Study Plan', icon: 'document' },
  { to: '/student/requests', label: 'Requests', icon: 'request' },
  { to: '/student/surveys', label: 'Surveys', icon: 'survey' },
  { to: '/student/forms', label: 'Forms', icon: 'document' },
  { to: '/student/profile', label: 'Profile', icon: 'profile' },
  { to: '/student/degree', label: 'MS Degree', icon: 'course' },
  { to: '/student/contact', label: 'Contact', icon: 'mail' }
];

const staffLinks = [
  { to: '/staff', label: 'Dashboard', icon: 'home' },
  { to: '/staff/requests', label: 'Requests', icon: 'request' },
  { to: '/staff/students', label: 'Students', icon: 'users' },
  { to: '/staff/surveys', label: 'Surveys', icon: 'survey' },
  { to: '/staff/pages', label: 'Pages', icon: 'document' },
  { to: '/staff/admins', label: 'Admins', icon: 'users' },
  { to: '/staff/settings', label: 'Settings', icon: 'settings' },
  { to: '/staff/emails', label: 'Emails', icon: 'mail' },
  { to: '/staff/logs', label: 'Logs', icon: 'log' },
  { to: '/staff/course-list', label: 'Course List', icon: 'course' },
  { to: '/staff/analytics', label: 'Analytics', icon: 'analytics' }
];

const adminOnlyLinks = new Set(['/staff/admins', '/staff/settings', '/staff/emails', '/staff/logs']);
const adminOrChairLinks = new Set(['/staff/surveys', '/staff/pages', '/staff/course-list']);

export default function Sidebar({ variant, user, open = true, onClose }) {
  const { path } = React.useContext(RouteContext);
  const links = variant === 'staff'
    ? staffLinks.filter((item) => canViewStaffLink(item.to, user))
    : studentLinks;

  return (
    <>
      <div
        className="sidebar-backdrop"
        onClick={onClose}
        aria-hidden={!open || undefined}
      />
      <aside className="sidebar" aria-hidden={!open || undefined}>
        <div className="sidebar-brand">
          <div className="sidebar-brand-info">
            <div className="brand-mark">
              <img src="/favicon.ico" alt="ECE" width="26" height="26" className="brand-mark-img" />
            </div>
            <div>
              <div className="brand-title">ECE Portal</div>
              <div className="brand-sub">Cal State LA</div>
            </div>
          </div>
        </div>
        <nav className="sidebar-nav" aria-label={`${variant} navigation`}>
          {links.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="sidebar-link"
              data-active={isActive(item.to, path) ? 'true' : undefined}
              onClick={onClose}
            >
              <Icon name={item.icon} className="sidebar-icon" />
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>
        <div className="sidebar-divider" />
        <div className="sidebar-footer">
          <Link to="/logout" className="sidebar-link" onClick={onClose}>
            <Icon name="logout" className="sidebar-icon" />
            <span>Logout</span>
          </Link>
        </div>
      </aside>
    </>
  );
}

function isActive(linkPath, currentPath) {
  if (linkPath === '/staff' || linkPath === '/student') {
    return currentPath === linkPath;
  }
  return currentPath === linkPath || currentPath.startsWith(linkPath + '/');
}

function canViewStaffLink(path, user) {
  if (!user) {
    return !adminOnlyLinks.has(path) && !adminOrChairLinks.has(path);
  }
  const isAdmin = user.admin_privilege === 1;
  const isChair = user.chair_privilege === 1;

  if (adminOnlyLinks.has(path)) return isAdmin;
  if (adminOrChairLinks.has(path)) return isAdmin || isChair;
  return true;
}
